import React from 'react';
import { Button, Container } from 'reactstrap';
import ShareBtn from '../components/ShareBtn';
import Nav from './Nav';
import Logo from '../logo_maxi.png';

import {Col,Row} from 'reactstrap';

class Greetings extends React.Component {
  constructor (props) {
    super(props);
      this.startList = this.startList.bind(this);
      this.logoClicked = this.logoClicked.bind(this);
  }

  componentDidMount(){

  }

  startList(e){
    window.dataLayer.push({
      eventCategory: 'accueil',
      eventAction: 'clicInterne',
      eventLabel: 'debuterListe',
      event: 'genericGAEvent'
  });

  this.props.handler(e);

  }

  logoClicked(e){
    window.dataLayer.push({
      eventCategory: 'accueil',
      eventAction: 'clicInterne',
      eventLabel: 'logoMaxi',
      event: 'genericGAEvent'
    });
  }

  render() {
    return(


    <React.Fragment>


      <Container className="containHome">
 <img src={Logo} alt="" onClick={this.logoClicked} style={{
          height:'75px',
          marginTop:'10px'
       }}/>




      <Row style={{
        position:"absolute",
        top:"12vh"
      }}className="homeStack">

      <Col lg="" xl="" id="">

      <h4 style={{

      }} id="Creer">Créez et partagez votre</h4>
      <h1 className="mainTitle">liste d<b>'</b>épicerie chantée !</h1>
      <h5 style={{

      }} id="parTiChoeur">par le choeur des petits mangeurs du mont-royal</h5>
      <div>
      <Button style={{
        maxWidth:"300px",
        fontSize:"20px",
        fontWeight:"bold",
        marginBottom:"30px",
        marginTop:"20px",
        padding:"15px",
        float:"left"
      }} className="startList" onClick={this.startList}>Commencer une liste</Button>

      </div>

          <div style={{
        width:"100%",
        display:"flex",
        marginBottom:"0px"
      }}>

        <p id="textePartage" style={{
          fontWeight:"bold",
          textAlign:"left",
          width:"100%"
        }}>1 LISTE PARTAGÉE = 1 $ POUR LUTTER CONTRE LA FAIM CHEZ LES ENFANTS </p>

      </div>

      <img style={{
        float:"left"
      }} className="partageFondation" src="/assets/branding/fondationSolo.png"  alt="Partage dons" />


      </Col>
      <Col lg="" xl="" id="">

      <img id="homeChorale" src="/assets/branding/Chorale.png" alt="Petite chorale!" />
</Col>
<p style={{
  fontWeight:"light",
}} id="legal">*Pour chaque liste partagée entre le 6 et le 26 décembre 2021, 1 $ sera remis à la Fondation pour les enfants le Choix du Président, jusqu'à concurrence de 15 000 $.</p>


</Row>


</Container>


<div className="flexParent" style={{
position:"fixed",
top:"10px",
justifyContent:"space-between",
width:"inherit",
maxWidth:"1920px"
}}>



                <div className="guiHome" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(-90deg)',
backgroundSize:"cover"
}}></div>






<div className="guiHome" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(-0deg)',

backgroundSize:"cover",
float:'right'
}}></div>




                </div>




<div className="flexParent" style={{
position:"fixed",
bottom:"0",
justifyContent:"space-between",
width:"inherit",
maxWidth:"1920px"
}}>




                <div className="guiHome" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(180deg)',
backgroundSize:"cover"
}}></div>





<div className="guiHome" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(90deg)',

backgroundSize:"cover",
float:'right'
}}></div>




                </div>


<div style={{
  justifyContent:"center"
}} className="flexParent">





</div>


<div style={{
  justifyContent:'flex-end'
}} className="flexParent">

<div className="" style={{

width:"29px ",
height:"76vh",
backgroundImage:"url('/assets/branding/cadre_home_side.png')",
backgroundSize:"cover",
backgroundRepeat:"no-repeat",
position:"fixed",
top:"0",
backgroundSize:"contain",
backgroundPosition:"center",
marginTop:"14vh",
transform:"rotate(180deg)"

}}></div>




</div>


<div style={{
  justifyContent:'flex-start'
}} className="flexParent">

<div className="" style={{

width:"29px ",
height:"76vh",
backgroundImage:"url('/assets/branding/cadre_home_side.png')",
backgroundSize:"contain",
backgroundRepeat:"no-repeat",
position:"fixed",
top:"0",
backgroundSize:"contain",
backgroundPosition:"center",
marginTop:"14vh",

}}></div>






</div>


    </React.Fragment>
     )
  }
}

export default Greetings;
//        <ShareBtn text="Partager"/>
